// ----------------------------------------------------------------------------
// Component: Jump To
// ----------------------------------------------------------------------------
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

module.exports = function() {
    // Open states for the Jump To
    $('.jump-to__label').click(function() {
        $(this).closest('.jump-to').toggleClass('jump-to--open');
    });
};
